import Nodo from './Nodo.js';
import Vorto from './Vorto.js';
import {BAZA_URL} from './Kunteksto.js';

class NodŜarĝilo
{
    constructor(agordilo, lingvoj)
    {
        this.agordilo = agordilo;
        this.lingvoj = lingvoj;
        this.lastaPeto = null;
    }

    agorduLingvojn (lingvoj)
    {
        this.lingvoj = lingvoj;
    }
    
    lingvojPorURL ()
    {
        return ('LINGVOJ=' + this.lingvoj.join(','));
    }
    
    ŝarĝuNodojn (patroid, kapnodoid = null, kategorio = null)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "nodoj.php?"+ this.lingvojPorURL() + (patroid === null ? "" : ("&NODO=" + patroid)) +
            (kapnodoid !== null && kategorio !== null ? ("&KAPNODO=" + kapnodoid + "&KATEGORIO=" + kategorio) : "");
        console.log (url);
        this.lastaPeto = {funkcio: 'ŝarĝuNodojn', patroid: patroid, kapnodoid: kapnodoid, kategorio:kategorio};
        request.open('GET', url);
        request.onload = function ()
        {
            const data = JSON.parse (request.responseText);
            mi.prilaboruRespondon (data);
        };
        request.send();
    }
    /*
    ŝarĝuNodonPorRedakti  (nodoid)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "nodoj.php?"+ this.lingvojPorURL() + (patroid === null ? "" : ("&NODO=" + patroid)) +
            (kapnodoid !== null && kategorio !== null ? ("&KAPNODO=" + kapnodoid + "&KATEGORIO=" + kategorio) : "");
        console.log (url);
        this.lastaPeto = {funkcio: 'ŝarĝuNodojn', patroid: patroid, kapnodoid: kapnodoid, kategorio:kategorio};
        request.open('GET', url);
        request.onload = function ()
        {
            const data = JSON.parse (request.responseText);
            mi.prilaboruRespondon (data);
        };
        request.send();
    }
    */
    reŝarĝuNodojnKunKategorioj (kapnodoid = null, kategorio = null)
    {
        var patroid;
        if (this.lastaPeto === null || this.lastaPeto.funkcio !== 'ŝarĝuNodojn')
        {
           patroid = null;           
        }
        else
        {
            patroid = this.lastaPeto.patroid;
        }
        
        this.ŝarĝuNodojn(patroid, kapnodoid, kategorio);        
    }
    
    ŝarĝuNodojnEnhavantajnVorton (vorto, lingvo, enTitoloj = true, enKapvortoj = true, enRilataj = true)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const kie = (enTitoloj ? 'T' : '') + (enKapvortoj ? 'K' : '') + (enRilataj ? 'R' : '');
        const url = BAZA_URL + "sercu.php?VORTO=" + encodeURIComponent(vorto) + "&LINGVO=" + lingvo + "&" + this.lingvojPorURL() + "&KIE=" + kie;
        console.log (url);
        this.lastaPeto = {funkcio: 'ŝarĝuNodojnEnhavantajnVorton', vorto: vorto, lingvo: lingvo};        
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            const data = JSON.parse (request.responseText);
            mi.prilaboruRespondon (data, lingvo, vorto);
        };
        request.send();
    }
    
    reŝarĝu ()
    {
        console.log ("reŝarĝu " + this.lastaPeto);
        if (this.lastaPeto === null)
        {
            return;
        }
        
        switch (this.lastaPeto.funkcio)
        {
            case 'ŝarĝuNodojn': this.ŝarĝuNodojn (this.lastaPeto.patroid, this.lastaPeto.kapnodoid, this.lastaPeto.kategorio);
            break;
            case 'ŝarĝuNodojnEnhavantajnVorton': this.ŝarĝuNodojnEnhavantajnVorton (this.lastaPeto.vorto, this.lastaPeto.lingvo);
                break;
            default: console.log ("Mi ne povas reŝarĝi.");
        }
    }
    
    prilaboruRespondon (data, serĉlingvo = null, serĉvorto = null)
    {
        //console.log ('prilaboruRespondon ', serĉlingvo, serĉvorto );
        var kapnodlisto = [];
        var listo = [];

        if (data.kapnodoj !== null)
        {
        for (var noddatumoj of data.kapnodoj)
        {
            var nodo = this.kreuNodon (noddatumoj);
            kapnodlisto.push (nodo);
        }
        }
        
        for (var noddatumoj of data.listo)
        {
            var nodo = this.kreuNodon (noddatumoj, serĉlingvo, serĉvorto);
            listo.push (nodo);
        }
        
        this.agordilo ({kapnodoj: kapnodlisto, listo: listo});
    }
    
    kreuNodon (noddatumoj, serĉlingvo = null, serĉvorto = null)
    {
        let dekorita_serĉvorto = serĉvorto !== null ? '[[' + serĉvorto + ']]' : '';
        var patro_id = noddatumoj.patro_id !== null ? parseInt(noddatumoj.patro_id) : null;
        var ordo = noddatumoj.ordo !== null ? parseInt (noddatumoj.ordo) : 0;
        var fina = noddatumoj.fina;
        var nodo = new Nodo(parseInt(noddatumoj.id), patro_id, parseInt(noddatumoj.kategorio), ordo, fina, noddatumoj.kategorioj);
        for (var vortdatumoj of noddatumoj.vortoj)
        {
            var lingvo = parseInt(vortdatumoj.lingvo);
            var signvorto = lingvo == serĉlingvo ? vortdatumoj.vorto.replace (serĉvorto, dekorita_serĉvorto) : vortdatumoj.vorto;
            var vorto = new Vorto(nodo, parseInt(vortdatumoj.id), lingvo, signvorto, vortdatumoj.priskribo, vortdatumoj.ordo, vortdatumoj.uzita);
            nodo.aldonuVorton(vorto);
        }
        return (nodo);
    }
    
    ŝanĝuVorton (nodoid, vortoid, vorto, ordo, cie=true)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agovorto.php?A=redakti2&NODO=" + encodeURIComponent (nodoid)
                    + "&ID=" + encodeURIComponent (vortoid) + "&VORTO=" + encodeURIComponent(vorto) + "&ORDO=" + encodeURIComponent(ordo)
                    + "&CIE="  + (cie ? 'TRUE' : 'FALSE');
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuVorton (request.responseText);
        };
        request.withCredentials = true;
        request.send();        
    }
    
    aldonuVorton (nodoid, lingvoid, vorto, ordo)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agovorto.php?A=aldoni&NODO=" + encodeURIComponent (nodoid) 
                    + "&LINGVO=" + encodeURIComponent (lingvoid) +"&VORTO=" + encodeURIComponent(vorto) + "&ORDO=" + encodeURIComponent(ordo);
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuVorton (request.responseText);
        };
        request.withCredentials = true;        
        request.send();        
    }
    
    foriguVorton (nodoid, vortoid)
    {
        console.log ("foriguVorton");
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agovorto.php?A=forigi&&ID=" + encodeURIComponent (vortoid) + "&NODO=" + encodeURIComponent (nodoid);
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuVorton (request.responseText);
        };
         request.withCredentials = true;     
         request.send();        
    }
        
    prilaboruRespondonŜanĝuVorton (data)
    {
        this.reŝarĝu();
    }
    
    ŝanĝuNodon (nodoid, patroid, kategorioid, ordo)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agonodo.php?A=redakti&ID=" + encodeURIComponent (nodoid) + "&PATRO=" + encodeURIComponent(patroid) +
                "&KATEGORIO=" + encodeURIComponent(kategorioid) + "&ORDO=" + encodeURIComponent(ordo) ;
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuNodon (request.responseText);
        };
        request.withCredentials = true;
        request.send();        
    }    
 
    aldonuNodon (patroid, kategorioid, ordo)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agonodo.php?A=krei&PATRO=" + encodeURIComponent(patroid) +
                "&KATEGORIO=" + encodeURIComponent(kategorioid) + "&ORDO=" + encodeURIComponent(ordo) ;
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            //const data = JSON.parse (request.responseText);
            mi.prilaboruRespondonŜanĝuNodon (request.responseText);
        };
        request.withCredentials = true;
        request.send();
    }  
    
    aldonuNodonSub (nodoid)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agonodo.php?A=kreiSub&NODO=" + encodeURIComponent(nodoid);
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            //const data = JSON.parse (request.responseText);
            mi.prilaboruRespondonŜanĝuNodon (request.responseText);
        };
        request.withCredentials = true;
        request.send();        
    }
    
    foriguNodon (nodoid)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agonodo.php?A=forigi&ID=" + encodeURIComponent(nodoid);
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuNodon (request.responseText);
        };
        request.withCredentials = true;
        request.send();    
    }
    
    unuiguNodojn (nodo1_id, nodo2_id)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agonodo.php?A=unuigi&NODO1=" + encodeURIComponent(nodo1_id) + "&NODO2="+ encodeURIComponent(nodo2_id);
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuNodon (request.responseText);
        };
        request.withCredentials = true;
        request.send();        
    }
    
    reagorduVortaron()
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "agonodo.php?A=reagordi";
        console.log (url);
        request.open('GET', url);
        request.onload = function ()
        {
            console.log(request.responseText);
            mi.prilaboruRespondonŜanĝuNodon (request.responseText);
        };
        request.withCredentials = true;
        request.send();
    }
    
    prilaboruRespondonŜanĝuNodon (data)
    {
        this.reŝarĝu();
    }
    
}

export default NodŜarĝilo;
